import { useEffect, useRef } from "react";
import { toast } from "sonner";
import api from "../lib/api";

const DAY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MSG = {
  dose: "Time for your dose — take it as agreed with your prescriber.",
  taper_step: "Taper step reminder — check your schedule when you're ready.",
  journal: "A gentle nudge to journal or log how today is going.",
};

// Foreground browser notifications: fire while the app tab is open/backgrounded.
export const ReminderScheduler = () => {
  const firedRef = useRef({});

  useEffect(() => {
    let reminders = [];
    const fetchReminders = async () => {
      try { const { data } = await api.get("/reminders"); reminders = data.reminders; } catch {}
    };
    fetchReminders();
    const refetch = setInterval(fetchReminders, 5 * 60 * 1000);

    const tick = () => {
      const now = new Date();
      const hhmm = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
      const today = DAY[now.getDay()];
      const dateKey = now.toISOString().slice(0, 10);
      reminders.forEach((r) => {
        if (!r.enabled || r.time !== hhmm) return;
        if (!(r.days || []).includes(today)) return;
        const key = `${r.id}-${dateKey}`;
        if (firedRef.current[key]) return;
        firedRef.current[key] = true;
        const body = r.label || MSG[r.kind] || "TaperPath reminder";
        toast(body, { description: "TaperPath reminder" });
      });
    };
    const t = setInterval(tick, 20 * 1000);
    return () => { clearInterval(t); clearInterval(refetch); };
  }, []);

  return null;
};
